import * as React from 'react';
import { view, createViewConfig } from '@sail/engine';
import { styles, variants } from './RowLayoutStyles';
export const RowLayoutConfig = createViewConfig({
    props: {},
    name: 'RowLayout',
    defaults: {
        gap: 'large',
        stretchLastItem: false
    }
});
/**
 * Layout component used to handle vertical stacking row layout
 */ export const RowLayout = RowLayoutConfig.createView(({ children, stretchLastItem, ...rest })=>{
    return /*#__PURE__*/ React.createElement(view.div, {
        ...rest,
        uses: styles.rowLayout,
        "data-stretch-last-item": stretchLastItem ? '' : undefined
    }, children);
}, {
    variants
});

//# sourceMappingURL=RowLayout.js.map